export default __webpack_public_path__ + "static/media/wallhole.f90b9b92.png";